(function() {
  'use strict';

  angular.module('component.announcements', []);
})();
